import { WidgetsRegex } from "../Widgets";
export function escapeXml(unsafe: any): string {
  if (!unsafe) return "";

  const str = String(unsafe);

  let result = "";
  let lastIndex = 0;

  const entityMap: Record<string, string> = {
    "<": "&lt;",
    ">": "&gt;",
    "&": "&amp;",
    "'": "&apos;",
    '"': "&quot;",
  };

  // Regex to match HTML entities
  const entityRegex = /^&[a-zA-Z0-9#][a-zA-Z0-9#]*;$/;

  /**
   * Helper function to escape XML special characters while preserving existing entities
   */
  function escapePart(text: string): string {
    return text.replace(/&[a-zA-Z0-9#][a-zA-Z0-9#]*;|[<>&'"]/g, (match) =>
      entityRegex.test(match) ? match : entityMap[match] || match,
    );
  }

  // Process all widget regex matches
  for (const regexPattern of WidgetsRegex) {
    // Convert the string pattern to RegExp if needed
    const regex =
      typeof regexPattern === "string"
        ? new RegExp(regexPattern, "g")
        : regexPattern;

    // Reset the regex for a fresh search
    if (regex instanceof RegExp) {
      regex.lastIndex = 0;
    }

    let match;
    // Find all matches in the string
    while ((match = regex.exec(str)) !== null) {
      // Escape the text before the match
      result += escapePart(str.substring(lastIndex, match.index));

      // Add the match as-is without escaping
      result += match[0];

      // Update lastIndex to continue after this match
      lastIndex = regex.lastIndex;
    }
  }

  // Escape any remaining text after all widget matches
  result += escapePart(str.substring(lastIndex));

  return result;
}

export function unescapeXml(escaped: string) {
  if (!escaped) return "";

  return escaped
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&")
    .replace(/&apos;/g, "'")
    .replace(/&quot;/g, '"');
}
